<template>
    <input
        type="checkbox"
        class="toggle toggle-gray toggle-on"
        :class="props.isToggleOn ? 'toggle-on' : 'toggle-off'"
        :checked="props.isToggleOn"
    >
</template>

<script>
export default {
    name: 'SwitchPolicyForm',
    props: {
        isToggleOn: {
            type: Boolean,
        },
    },
    setup(props) {
        return { props };
    },
};
</script>

<style scoped>
.toggle-gray {
    position: relative;
    height: 40px;
    width: 80px;
    border-radius: 5px;
    --handleoffset: 40px;
    --chkbg: white;
    border-color: #cccccc;
    --tw-border-opacity: 0.1;
    --tw-bg-opacity: 1;
    background-color: white;
    --tw-text-opacity: 1;
    color: white;
    box-shadow: calc(var(--handleoffset) * -1) 0 0 0px #666666 inset,
        0 0 0 0px #666666 inset;
}

.toggle-gray:checked,
.toggle-gray[checked="true"] {
    box-shadow: var(--handleoffset) 0 0 0px #666666 inset,
        0 0 0 0px #666666 inset;
}

.toggle-gray::after {
    content: "";
    position: absolute;
    display: block;
    width: 22px;
    height: 22px;
    right: 24%;
    top: 50%;
    transform: translateX(50%) translateY(-50%);
    background-size: cover;
}

.toggle-gray::before {
    content: "";
    position: absolute;
    display: block;
    width: 22px;
    height: 22px;
    background-size: cover;
    left: 25%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.toggle-on::after {
    background-image: url("../../assets/images/switch/format_list_bulleted.svg");
}

.toggle-off::after {
    background-image: url("../../assets/images/switch/format_list_bulleted_white.svg");
}

.toggle-on::before {
    background-image: url("../../assets/images/switch/grid_view_white.svg");
}

.toggle-off::before {
    background-image: url("../../assets/images/switch/grid_view.svg");
}
</style>
